import { render, staticRenderFns } from "./cardFeaturedSponsorsLanding.vue?vue&type=template&id=5c2de705&scoped=true"
import script from "./cardFeaturedSponsorsLanding.vue?vue&type=script&lang=js"
export * from "./cardFeaturedSponsorsLanding.vue?vue&type=script&lang=js"
import style0 from "./cardFeaturedSponsorsLanding.vue?vue&type=style&index=0&id=5c2de705&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2de705",
  null
  
)

export default component.exports